import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconLink16Group: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#1C47CA', props);
  const clipPathId = `${props.groupIdPrefix ?? 'icon-link-16'}-clip`;

  return (
    <g clipPath={`url(#${clipPathId})`} fill="none" {...(props.group ?? {})}>
      <path
        d="M9.99996 4.66602H12C12.4377 4.66602 12.8712 4.75223 13.2756 4.91975C13.68 5.08727 14.0475 5.3328 14.357 5.64233C14.6665 5.95185 14.912 6.31932 15.0796 6.72374C15.2471 7.12816 15.3333 7.56161 15.3333 7.99935C15.3333 8.43709 15.2471 8.87054 15.0796 9.27496C14.912 9.67938 14.6665 10.0468 14.357 10.3564C14.0475 10.6659 13.68 10.9114 13.2756 11.0789C12.8712 11.2465 12.4377 11.3327 12 11.3327H9.99996M5.99996 11.3327H3.99996C3.56222 11.3327 3.12877 11.2465 2.72435 11.0789C2.31993 10.9114 1.95247 10.6659 1.64294 10.3564C1.01782 9.73125 0.666626 8.8834 0.666626 7.99935C0.666626 7.11529 1.01782 6.26745 1.64294 5.64233C2.26806 5.01721 3.1159 4.66602 3.99996 4.66602H5.99996"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 8H10.6667"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </g>
  );
};

export const IconLink16Svg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconLink16Group {...props} />
    </svg>
  );
};
